import React from 'react';
export function SuccessInsert() {
  return <section className="py-12 px-5" data-id="element-277">
      <div className="max-w-lg mx-auto" data-id="element-278">
        <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-279">
          {/* Image — clean, no filters */}
          <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-280">
            <img src="https://cdn.magicpatterns.com/uploads/9ssQ31DPucgnDVXtaQyh5u/imagen_landing1.png" alt="Perro relajado en terraza" className="w-full h-auto rounded-xl object-cover" data-id="element-281" />
          </div>

          {/* Text block */}
          <div className="w-full md:w-1/2" data-id="element-282">
            <h3 className="font-serif text-2xl md:text-3xl text-white leading-snug mb-4 italic" data-id="element-283">
              Tu nueva vida empieza aquí.
            </h3>
            <p className="text-white/70 leading-relaxed" data-id="element-284">
              Imagina bajar a tomar un café y que tu única preocupación sea
              disfrutar del aroma. Sin tirones. Sin disculpas. Solo paz.
            </p>
          </div>
        </div>
      </div>
    </section>;
}